import { Theme } from "@mui/material/styles";
import { neutral } from "app/themes/colors";
import { inputBaseClasses } from "@mui/material/InputBase";

export const DEFAULT_LABEL_CONFIG = {
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: 0.7,
  position: "unset",
  transform: "none",
  "& +.MuiInputBase-root": {
    marginTop: 0,
  },
};

export const getInputComponents = (sunoTheme: Theme) => ({
  MuiInputBase: {
    styleOverrides: {
      input: {
        fontSize: sunoTheme.typography.pxToRem(16),
        lineHeight: sunoTheme.typography.pxToRem(22),
        letterSpacing: 0,
        "&::placeholder": {
          color: neutral[600],
          opacity: 1,
        },
        padding: "8px 12px !important",
      },
      multiline: {
        padding: "0 !important",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        ...DEFAULT_LABEL_CONFIG,
        paddingBottom: sunoTheme.typography.pxToRem(4),
      },
      filled: {
        transform: "unset",
      },
      outlined: {},
    },
  },

  MuiFormHelperText: {
    styleOverrides: {
      root: {
        marginLeft: 0,
      },
    },
  },

  MuiAutocomplete: {
    styleOverrides: {
      inputRoot: {
        "&:not(:has(.MuiAutocomplete-tag))": {
          padding: 0,
        },
        "&:not(:has(.MuiSvgIcon-root))": {
          padding: 0,
        },
      },
    },
  },
  MuiTextField: {
    defaultProps: {},
  },
  MuiOutlinedInput: {
    defaultProps: {
      notched: false,
      label: false,
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        "&.MuiTextField-root": {
          backgroundColor: "unset",
        },
        "& .MuiInputBase-root": {
          backgroundColor: "white",
        },
        [`label[data-shrink=false] + .${inputBaseClasses.formControl}`]: {
          [`.${inputBaseClasses.input}::placeholder`]: {
            opacity: "0.6 !important",
          },
        },
      },
    },
  },
});
